import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useHistoricLog() {
  const {
    waterQuality: {
      filterFlowrates: {
        graphicLog: { year, week, day, dataPoint },
      },
    },
  } = useSelector(({ state }) => state);
  const { data = { HistoricFlowratesLog: [] }, loading } = useQuery(GET_OVERVIEW, {
    variables: { year, week, day },
    skip: !year && !week && !day,
  });
  let dataOverview = [];
  data.HistoricFlowratesLog.forEach((rows) => {
    if (rows.data_point !== dataPoint) return;
    dataOverview.push(rows);
  });
  return { loading, data: dataOverview || [] };
}

const GET_OVERVIEW = gql`
  query ReportResponseFlowratesLog($year: Int!, $week: Int!, $day: Int!) {
    HistoricFlowratesLog: ReportResponseFlowratesLog(year: $year, week: $week, day: $day) {
      _id
      text
      data_point
      color
      data {
        _id
        hour
        value
      }
    }
  }
`;
